import { variablesGlobales } from '../../configs/variables';
import getInstanceAxios from '../axiosInstance';

export class AuthService {


    static async generateTokenClient(data={}) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/auth/generate-token`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async validateToken(data = {}, medium = "") {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(
                `${variablesGlobales.urlServiceBackend}/api/v1/auth/validate-token?medium=${medium}`,
                data,
                {withCredentials:true}
            );
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };
        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async logout(data = {}) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(
                `${variablesGlobales.urlServiceBackend}/api/v1/session/logout`,
                data
            );
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };
        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async validateSessionAndJwtToken() {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.get(`${variablesGlobales.urlServiceBackend}/api/v1/session/validateSessionAndJwtToken`);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async confirmPhoneToUpdatePhone(data = {}) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(
                `${variablesGlobales.urlServiceBackend}/api/v1/auth/confirmPhoneToUpdatePhone`,
                data
            );
            return {
                error: false,
                message: responseServer?.data,
                date: new Date()
            };
        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async confirmOtpToUpdatePhone(data = {}) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(
                `${variablesGlobales.urlServiceBackend}/api/v1/auth/confirmOtpToUpdatePhone`,
                data
            );
            return {
                error: false,
                message: responseServer?.data,
                date: new Date()
            };
        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async confirmEmailToUpdateEmail(data = {}) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(
                `${variablesGlobales.urlServiceBackend}/api/v1/auth/confirmEmailToUpdateEmail`,
                data
            );
            return {
                error: false,
                message: responseServer?.data,
                date: new Date()
            };
        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

    static async confirmOtpToUpdateEmail(data = {}){
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(
                `${variablesGlobales.urlServiceBackend}/api/v1/auth/confirmOtpToUpdateEmail`,
                data
            );
            return {
                error: false,
                message: responseServer?.data,
                date: new Date()
            };
        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }

}